import Cookies from 'js-cookie';
import * as KKWebCommon from '_c/index';
import { BuildConfigService } from '@/business/service/build-config';
import { UserService } from '@/business/service/user-service';
import { Base64 } from 'js-base64';
import { env } from '_c/util/browser-env';
import { SystemType } from '_c/typings/proto';
import { logger } from '_c/util/logger';

let commonReq = '';

export function getCommonReq() {
  if (commonReq) {
    return commonReq;
  }

  const clientInfo = {
    sys_id: env.isMac ? SystemType.SystemTypeMacOS : SystemType.SystemTypeWindows,
    platform: 1,
  };
  try {
    commonReq = Base64.encode(JSON.stringify({ client_info: clientInfo }));
  } catch (e) {
    logger.error('getCommonReq', e);
  }
  return commonReq;
}

export default function service() {
  KKWebCommon.setup({
    netOptions: {
      headers: {
        'x-kk-h5commreq': getCommonReq(),
      },
      baseURL: import.meta.env.VITE_API_BASE_URL,
      getTokenKey: () => Cookies.get('lu_token') || '',
    },
    reportOptions: {
      commonReportData: {
        sysId: env.isMac ? SystemType.SystemTypeMacOS : SystemType.SystemTypeWindows,
      },
    },
  });


  /**
   * 注册服务
   */
  KKWebCommon.bindService('BuildConfigService', BuildConfigService);
  KKWebCommon.bindService('UserService', UserService);
}

